// MAINTENANCE WINDOW (Karan 21/10/2026). One app-wide record, app/maintenance
// { from, until, message } (ISO times), set by the deploy side — changing or
// clearing it takes effect in every open tab without a redeploy.
//   before `from` (within 24 h): a notice bar on every screen;
//   from ≤ now < until: a full-screen pause over the app — an Owner may continue
//   (to check the work); everyone else waits, and Track comes back by itself.
import { doc, onSnapshot } from './fb/firestore.js';
import { db } from './firebase.js';
import { escapeHtml } from './ui.js';

const BYPASS = 'track.maintenance.bypass';
let state = null;
let timer = null;
const ukTime = (iso) => new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' });

function clear() {
  document.getElementById('mx-bar')?.remove();
  document.getElementById('mx-pause')?.remove();
  document.body.classList.remove('update-banner-open');
}

function paint(session) {
  clear();
  if (!state || !state.from || !state.until) return;
  const now = Date.now(); const from = Date.parse(state.from); const until = Date.parse(state.until);
  if (!(until > now)) return;
  if (now < from) {
    if (from - now > 24 * 3600 * 1000) return;
    const bar = document.createElement('div');
    bar.id = 'mx-bar'; bar.className = 'update-banner'; bar.setAttribute('role', 'status');
    bar.innerHTML = `<span>${escapeHtml(state.message || `Track will be unavailable for maintenance from ${ukTime(state.from)} to ${ukTime(state.until)} UK today. Please save your work before then.`)}</span>`;
    document.body.classList.add('update-banner-open');
    document.body.appendChild(bar);
    return;
  }
  let bypass = false; try { bypass = sessionStorage.getItem(BYPASS) === state.until; } catch (_) { /* storage blocked */ }
  if (bypass) return;
  const owner = !!(session && (session.roles || []).includes('Owner'));
  const box = document.createElement('div');
  box.id = 'mx-pause'; box.setAttribute('role', 'alertdialog'); box.setAttribute('aria-modal', 'true');
  box.style.cssText = 'position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:calc(24px + env(safe-area-inset-top)) 24px calc(24px + env(safe-area-inset-bottom));background:var(--ground);color:var(--ink)';
  box.innerHTML = `<div style="max-width:440px;text-align:left">
    <div style="font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--brand-orange);margin-bottom:10px">Maintenance</div>
    <div style="font-size:22px;font-weight:500;margin-bottom:10px">Track is down for maintenance until ${escapeHtml(ukTime(state.until))} UK</div>
    <div style="font-size:14px;color:var(--ink-2);line-height:1.5">Nothing you saved is affected. This page will come back by itself when the work is finished.</div>
    ${owner ? '<button type="button" class="btn" id="mx-continue" style="margin-top:20px;min-height:44px">Continue anyway (Owner)</button>' : ''}
  </div>`;
  document.body.appendChild(box);
  box.querySelector('#mx-continue')?.addEventListener('click', () => {
    try { sessionStorage.setItem(BYPASS, state.until); } catch (_) { /* storage blocked */ }
    paint(session);
  });
}

/** Watch app/maintenance for the signed-in session. */
export function watchMaintenance(session) {
  onSnapshot(doc(db, 'app/maintenance'), (snap) => {
    state = snap.exists() ? snap.data() : null;
    paint(session);
  }, () => { /* no maintenance record readable: nothing to show */ });
  clearInterval(timer);
  timer = setInterval(() => paint(session), 30 * 1000);
}
